/* ============================================================================
   ENGORI — Texte in der Kaufbox bleiben auf EINER Zeile (27.09.2026)

   Vorbild Nordstealth: Schriftgroesse folgt der verfuegbaren Breite
   (dort per `font-size: min(Xpx, Ncqi)` mit festem Faktor je Text). Bei ENGORI
   sind die Texte je Produkt verschieden lang, ein fester Faktor passt also
   nicht. Deshalb wird gemessen statt geschaetzt:

     1. Element bekommt `white-space: nowrap` (Klasse .eng-1z, CSS in
        engori-premium.css) und die CSS-Schriftgroesse als Obergrenze.
     2. Ist der Text breiter als sein Platz, wird die Schrift genau so weit
        verkleinert, dass er passt — nie kleiner als das Minimum je Element.
     3. Reicht auch das Minimum nicht, darf der Text ausgewogen umbrechen
        (.eng-1z--frei, text-wrap: balance). Abgeschnitten wird NIE.

   Neu gemessen wird bei Breitenaenderung (ResizeObserver), nach dem Laden der
   Schriften und wenn die Staffel ihre Farbplaetze neu aufbaut.
   ========================================================================= */
(function () {
  'use strict';

  /* Selektor -> kleinste erlaubte Schrift in px */
  var ZIELE = [
    ['.product__info-container h1 .eng-titel-name', 13],
    ['.eng-tag__text', 10],
    ['.eng-bnf__title', 10],
    ['.eng-bnf__sub', 9.5],
    ['.eng-ab__teil', 11],
    ['.eng-stf__legend', 10],
    ['.eng-stf__picker-titel-text', 10],
    ['.eng-stf__menge', 11],
    ['.eng-stf__zusatz', 10],
    ['.eng-stf__wahl-name', 10.5],
    ['.eng-stf__cta-haupt > span', 12],
    ['.sticky-atc__title', 11],
    ['.eng-ci__name', 11.5],
    ['.product__info-container .accordion__title', 12]
  ];

  var basis = new WeakMap();   /* Element -> urspruengliche Schriftgroesse */
  var beobachtet = new WeakSet();
  var ro = window.ResizeObserver ? new ResizeObserver(function (e) {
    e.forEach(function (x) { passe(x.target._eng1z || x.target); });
  }) : null;

  function passe(el) {
    if (!el || !el.isConnected || el.offsetParent === null) return;
    el.classList.remove('eng-1z--frei');
    el.style.removeProperty('font-size');
    var max = basis.get(el);
    if (!max) { max = parseFloat(getComputedStyle(el).fontSize); basis.set(el, max); }
    var min = +el.dataset.eng1zMin || 10;
    var platz = el.clientWidth, noetig = el.scrollWidth;
    if (!platz || noetig <= platz + 0.5) return;
    var fs = Math.floor(max * (platz / noetig) * 4) / 4;
    if (fs < min) { el.classList.add('eng-1z--frei'); return; }
    el.style.setProperty('font-size', fs + 'px', 'important');
    /* Zweiter Schritt: Buchstabenbreiten skalieren nicht exakt linear */
    if (el.scrollWidth > el.clientWidth + 0.5) {
      fs = Math.floor(fs * (el.clientWidth / el.scrollWidth) * 4) / 4;
      if (fs < min) { el.style.removeProperty('font-size'); el.classList.add('eng-1z--frei'); return; }
      el.style.setProperty('font-size', fs + 'px', 'important');
    }
  }

  function sammle() {
    ZIELE.forEach(function (z) {
      Array.prototype.forEach.call(document.querySelectorAll(z[0]), function (el) {
        if (!el.classList.contains('eng-1z')) {
          el.classList.add('eng-1z');
          el.dataset.eng1zMin = z[1];
        }
        if (ro && !beobachtet.has(el) && el.parentElement) {
          beobachtet.add(el);
          el.parentElement._eng1z = el;
          ro.observe(el.parentElement);
        }
        passe(el);
      });
    });
  }

  var geplant = false;
  function spaeter() {
    if (geplant) return;
    geplant = true;
    setTimeout(function () { geplant = false; sammle(); }, 60);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sammle);
  else sammle();
  window.addEventListener('load', sammle);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(sammle);
  document.addEventListener('shopify:section:load', spaeter);

  /* Staffel baut Farbplaetze und Picker-Titel per Skript auf */
  if (window.MutationObserver) {
    new MutationObserver(function (l) {
      for (var i = 0; i < l.length; i++) {
        var t = l[i].target;
        if (t.nodeType === 1 && t.closest && t.closest('.eng-stf, .eng-ci-list, .product__info-container')) { spaeter(); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
